module.exports = __webpack_public_path__ + "media/audio1.7f760e76.mp3";